import SystemPlanRow from './SystemPlanRow';
import type { PlanSimpleDTO } from '../../types/plans/Plans';

interface SystemPlansTableProps {
  plans: PlanSimpleDTO[];
  onChangePlan: (planCode: string) => void;
}

const SystemPlansTable = ({ plans, onChangePlan }: SystemPlansTableProps) => {
  return (
    <div className="space-y-4">
      {plans.map((plan) => (
        <SystemPlanRow
          key={plan.code}
          plan={plan}
          onChangePlan={onChangePlan}
        />
      ))}
    </div>
  );
};

export default SystemPlansTable;
